<template functional>
  <component
    :is="injections.components.VueContentLoading"
    :primary="parent.$scss.colors.cardBg"
    :secondary="parent.$scss.colors.inputBg"
    :height="196"
  >
    <rect x="0" y="0" rx="4" ry="4" width="400" height="196"></rect>
  </component>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'TournamentCardLoader',
  inject: {
    components: {
      default: {
        VueContentLoading,
      },
    },
  },
};
</script>
